import React from "react"
import * as styles from "../styles/title.module.scss"

const Title = props => {
  return (
    <section className={`${styles.title} ${!props.background ? "fog" : ""}`}>
        <div className="container">
          <h1>{props.title}</h1>
          {props.subtitle ? <p>{props.subtitle}</p> : ''}
        </div>
    </section>
  )
}

export default Title
